import { inject, injectable } from "inversify";
import { GuidSelectModel, ICPLClientPortalPropertiesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalPropertiesService {
  getPropertySelectModels(): Promise<GuidSelectModel[]>;
}

@injectable()
export class ClientPortalPropertiesService implements IClientPortalPropertiesService {
  @inject(SERVICE_TYPES.CPLClientPortalPropertiesClient)
  cplClientPortalPropertiesClient!: ICPLClientPortalPropertiesClient;

  async getPropertySelectModels(): Promise<GuidSelectModel[]> {
    return this.cplClientPortalPropertiesClient.getPropertySelectModels();
  }
}
